import batch from './batch';
import contact from './contact';
import devices from './devices';
import deviceTypes from './deviceTypes';
import group from './group';
import location from './location';
import repair from './repair';
import payment from './payment';
import scheduledWindow from './scheduled-window';
import selectedDevices from './selected-devices';
import review from './review';
import progressBar from './progress-bar';
import settings from './settings';
import dynamicContent from './dynamic-content';
import locale from './locale';
import pageText from './page-text';

const createRootReducer = {
  batch,
  contact,
  devices,
  deviceTypes,
  dynamicContent,
  group,
  location,
  payment,
  repair,
  review,
  progressBar,
  scheduledWindow,
  selectedDevices,
  settings,
  locale,
  pageText,
};

export default createRootReducer;
